import React, {useEffect, useState} from "react";
import popupStyles from "./ChromeReminder.styles";

const ChromeReminder = () => {
    const [showPopup, setShowPopup] = useState(false);

    const isChromeBrowser = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        const isDesktopChrome =
        /Chrome/.test(userAgent) &&
        /Google Inc/.test(navigator.vendor) &&
        !/Edg/.test(userAgent) &&
        !/OPR/.test(userAgent);

        const isAndroidChrome =
        /Android/.test(userAgent) &&
        /Chrome/.test(userAgent) &&
        !/Edg/.test(userAgent) &&
        !/OPR/.test(userAgent);

        const isIOSChrome = /CriOS/.test(userAgent); // Chrome on iOS
        const isMobileChrome = /Google Inc/.test(navigator.vendor);

        return isDesktopChrome || isAndroidChrome || isIOSChrome || isMobileChrome;
    };

    useEffect(() => {
        if (!isChromeBrowser()) {
            setShowPopup(true);
        }
    }, []);

    if (!showPopup) return null;

    return (
        <>
            <div style={popupStyles.overlay}>
                <div style={popupStyles.popup}>
                    <h2>Please use Google Chrome</h2>
                    <p>For the best experience, we recommend using Google Chrome.
                        <a
                            href={"https://www.google.com/chrome/"}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="chrome link"
                        >
                            (Download Chrome)
                        </a>
                    </p>
                    <button onClick={() => setShowPopup(false)}>OK</button>
                </div>
            </div>
        </>
    );
};

export default ChromeReminder;
